(function () {

  /* ==================================================
     GELDBETRÄGE FORMATIEREN
     ================================================== */

  function formatMoney(cents) {
    const value = cents / 100;

    return new Intl.NumberFormat(
      document.documentElement.lang || 'de-DE',
      {
        style: 'currency',
        currency: 'EUR'
      }
    ).format(value);
  }


  /* ==================================================
     MENGENSTAFFEL INITIALISIEREN
     ================================================== */

  function initZtQuantityBreaks() {
    const groups = document.querySelectorAll(
      '[data-zt-quantity-breaks]'
    );

    groups.forEach(function (group) {
      if (group.dataset.initialized === 'true') {
        return;
      }

      group.dataset.initialized = 'true';

      const cards = Array.from(
        group.querySelectorAll('[data-zt-quantity-card]')
      );

      const productInfo =
        group.closest('product-info') || document;

      const priceDataElement = group.querySelector(
        '[data-zt-variant-prices]'
      );

      let variantPrices = {};


      /* ==================================================
         VARIANTENPREISE AUS JSON LESEN
         ================================================== */

      if (priceDataElement) {
        try {
          variantPrices = JSON.parse(
            priceDataElement.textContent
          );
        } catch (error) {
          console.warn(
            'ZT Mengenstaffel: Variantpreise konnten nicht gelesen werden.',
            error
          );
        }
      }


      /* ==================================================
         AKTUELLE VARIANTEN-ID
         ================================================== */

      function getCurrentVariantId() {
        const forms = productInfo.querySelectorAll(
          'form[action*="/cart/add"]'
        );

        for (const form of forms) {
          const idInput = form.querySelector(
            'input[name="id"]'
          );

          if (idInput && idInput.value) {
            return idInput.value;
          }
        }

        return group.dataset.selectedVariant;
      }


      /* ==================================================
         AKTUELLER BASISPREIS
         ================================================== */

      function getCurrentVariantPrice() {
        const variantId = getCurrentVariantId();

        if (
          variantId &&
          variantPrices[variantId] !== undefined
        ) {
          return Number(variantPrices[variantId]);
        }

        return 0;
      }


      /* ==================================================
         MENGE IM PRODUKTFORMULAR SETZEN
         ================================================== */

      function setQuantity(quantity) {
        productInfo
          .querySelectorAll('form[action*="/cart/add"]')
          .forEach(function (form) {
            let quantityInput = form.querySelector(
              'input[name="quantity"]'
            );

            if (!quantityInput) {
              quantityInput = document.createElement('input');
              quantityInput.type = 'hidden';
              quantityInput.name = 'quantity';
              form.appendChild(quantityInput);
            }

            quantityInput.value = quantity;

            quantityInput.dispatchEvent(
              new Event('change', { bubbles: true })
            );
          });

        productInfo
          .querySelectorAll(
            'quantity-input input[name="quantity"]'
          )
          .forEach(function (input) {
            input.value = quantity;

            input.dispatchEvent(
              new Event('change', { bubbles: true })
            );
          });
      }


      /* ==================================================
         PREISE DER MENGENKARTEN BERECHNEN
         ================================================== */

      function getTestsPerPack() {
        const count = Number(group.dataset.testsPerPack || '1');
        return Number.isSafeInteger(count) && count > 0 ? count : 0;
      }

      function updatePrices() {
        const basePrice = getCurrentVariantPrice();

        if (!basePrice) {
          return;
        }

        cards.forEach(function (card) {
          const quantity = Number(
            card.dataset.quantity || 1
          );

          const discount = Number(
            card.dataset.discount || 0
          );

          const regularTotal = basePrice * quantity;
          const compareTotal = quantity === 1
            ? Number(group.dataset.variantComparePrice || 0)
            : (discount > 0 ? regularTotal : 0);

          const discountedTotal = Math.round(
            regularTotal * (1 - discount / 100)
          );

          const totalTestCount = quantity * getTestsPerPack();
          const unitPrice = totalTestCount > 0
            ? Math.round(discountedTotal / totalTestCount)
            : 0;

          card.dataset.testCount = String(totalTestCount);

          const priceElement = card.querySelector(
            '[data-zt-quantity-price]'
          );

          const compareElement = card.querySelector(
            '[data-zt-quantity-compare]'
          );

          const unitPriceElement = card.querySelector(
            '[data-zt-quantity-unit-price]'
          );

          if (priceElement) {
            priceElement.textContent = formatMoney(
              discountedTotal
            );
          }

          if (compareElement) {
            if (compareTotal > 0) {
              compareElement.textContent = formatMoney(
                compareTotal
              );

              compareElement.classList.remove(
                'is-hidden'
              );
            } else {
              compareElement.textContent = '';

              compareElement.classList.add(
                'is-hidden'
              );
            }
          }

          if (unitPriceElement) {
            unitPriceElement.textContent =
              totalTestCount > 0 ? formatMoney(unitPrice) + '/Test' : '';
          }

          card.dataset.price = String(
            discountedTotal
          );

          card.dataset.priceFormatted = formatMoney(
            discountedTotal
          );

          card.dataset.unitPrice = String(unitPrice);
          card.dataset.unitPriceFormatted = totalTestCount > 0
            ? formatMoney(unitPrice)
            : '';

          if (compareTotal > 0) {
            card.dataset.comparePrice = String(
              compareTotal
            );

            card.dataset.comparePriceFormatted = formatMoney(
              compareTotal
            );
          } else {
            card.dataset.comparePrice = '';
            card.dataset.comparePriceFormatted = '';
          }
        });
      }


      /* ==================================================
         EIGENEN HAUPTPREIS FINDEN
         ================================================== */

      function getMainPriceBox() {
        return (
          productInfo.querySelector('[data-zt-product-price]') ||
          document.querySelector('[data-zt-product-price]')
        );
      }


      /* ==================================================
         HAUPTPREIS AUS MENGENKARTE AKTUALISIEREN
         ================================================== */

      function updateMainPrice(card) {
        if (!card) {
          return;
        }

        const priceBox = getMainPriceBox();

        if (!priceBox) {
          console.warn(
            'ZT Mengenstaffel: Dynamischer Produktpreis wurde nicht gefunden.'
          );
          return;
        }

        const quantity = Number(
          card.dataset.quantity || 1
        );

        const totalTestCount = Number(
          card.dataset.testCount || quantity * getTestsPerPack()
        );

        const discount = Number(
          card.dataset.discount || 0
        );

        let price =
          card.dataset.priceFormatted || '';

        let comparePrice =
          card.dataset.comparePriceFormatted || '';

        let unitPrice =
          card.dataset.unitPriceFormatted || '';

        if (!price) {
          const priceElement = card.querySelector(
            '[data-zt-quantity-price]'
          );

          if (priceElement) {
            price = priceElement.textContent.trim();
          }
        }

        if (!comparePrice) {
          const compareElement = card.querySelector(
            '[data-zt-quantity-compare]'
          );

          if (compareElement) {
            comparePrice = compareElement.textContent.trim();
          }
        }

        if (!unitPrice) {
          const unitPriceElement = card.querySelector(
            '[data-zt-quantity-unit-price]'
          );

          if (unitPriceElement) {
            unitPrice = unitPriceElement.textContent
              .replace('/Test', '')
              .trim();
          }
        }

        const currentElement = priceBox.querySelector(
          '[data-zt-price-current]'
        );

        const compareElement = priceBox.querySelector(
          '[data-zt-price-compare]'
        );

        const badgeElement = priceBox.querySelector(
          '[data-zt-price-badge]'
        );

        const unitElement = priceBox.querySelector(
          '[data-zt-unit-price]'
        );

        if (currentElement) {
          currentElement.textContent = price;
        }

        if (comparePrice && (quantity === 1 || discount > 0)) {
          priceBox.classList.add('is-sale');

          if (compareElement) {
            compareElement.textContent = comparePrice;
            compareElement.hidden = false;
          }

          if (badgeElement) {
            badgeElement.textContent = discount > 0
              ? 'Spare ' + discount + ' %'
              : '';
            badgeElement.hidden = discount <= 0;
          }
        } else {
          priceBox.classList.remove('is-sale');

          if (compareElement) {
            compareElement.textContent = '';
            compareElement.hidden = true;
          }

          if (badgeElement) {
            badgeElement.textContent = '';
            badgeElement.hidden = true;
          }
        }

        /*
         * Preis-pro-Test Badge im Hauptpreis:
         * bewusst erst ab 2 Tests anzeigen.
         */
        if (unitElement) {
          if (totalTestCount > 1 && unitPrice) {
            unitElement.textContent =
              'nur ' + unitPrice + '/Test';
            unitElement.hidden = false;
          } else {
            unitElement.textContent = '';
            unitElement.hidden = true;
          }
        }

        priceBox.dataset.quantity = String(quantity);
        priceBox.dataset.testCount = String(totalTestCount);
      }


      /* ==================================================
         AKTIVE KARTE SETZEN
         ================================================== */

      function setActiveCard(card) {
        cards.forEach(function (item) {
          item.classList.remove('is-active');
        });

        card.classList.add('is-active');
      }


      /* ==================================================
         AKTIVEN PREIS NEU BERECHNEN
         ================================================== */

      function refreshActivePrice() {
        updatePrices();

        const activeCard = group.querySelector(
          '[data-zt-quantity-card].is-active'
        );

        if (activeCard) {
          updateMainPrice(activeCard);
        }
      }


      /* ==================================================
         KLICK AUF MENGENKARTE
         ================================================== */

      cards.forEach(function (card) {
        card.addEventListener('click', function () {
          const quantity = Number(
            card.dataset.quantity || 1
          );

          setActiveCard(card);
          setQuantity(quantity);
          updateMainPrice(card);
        });
      });


      /* ==================================================
         VARIANTENÄNDERUNG
         ================================================== */

      productInfo
        .querySelectorAll(
          'form[action*="/cart/add"] input[name="id"]'
        )
        .forEach(function (input) {
          input.addEventListener('change', function () {
            window.setTimeout(refreshActivePrice, 0);
          });
        });


      /* ==================================================
         NATIVER SHOPIFY VARIANTENPICKER
         ================================================== */

      productInfo
        .querySelectorAll(
          'variant-selects input, variant-selects select, variant-radios input'
        )
        .forEach(function (input) {
          input.addEventListener('change', function () {
            window.setTimeout(refreshActivePrice, 50);
          });
        });


      /* ==================================================
         INITIALISIERUNG
         ================================================== */

      setQuantity(1);
      updatePrices();

      const initialCard =
        group.querySelector(
          '[data-zt-quantity-card].is-active'
        ) || cards[0];

      if (initialCard) {
        setActiveCard(initialCard);
        updateMainPrice(initialCard);
      }
    });
  }


  document.addEventListener(
    'DOMContentLoaded',
    initZtQuantityBreaks
  );

  document.addEventListener(
    'shopify:section:load',
    initZtQuantityBreaks
  );

})();
